"use strict";
import React from "react";
import reactUtils from "../../react_utils";
const bem = reactUtils.makeBem("invoice-action-bar");
function handler(f) {
  return (event) => {
    event.stopPropagation();
    event.preventDefault();
    f();
  };
}
function renderActions(props, state) {
  return props.actions.map((action, i) => renderAction(state, action, i));
}
function renderAction(state, action, i) {
  if (state.expanded) {
    return /* @__PURE__ */ React.createElement("div", { key: `action_button_${i}` }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "button--confirmation",
        onClick: handler(action.action)
      },
      action.label
    ));
  } else {
    return /* @__PURE__ */ React.createElement("div", { key: `action_link_${i}` }, /* @__PURE__ */ React.createElement("button", { className: "button", onClick: handler(action.action) }, action.label));
  }
}
export default React.createClass({
  getInitialState() {
    return {
      expanded: false
    };
  },
  render() {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: bem("__container"),
        onMouseEnter: this.expand,
        onMouseLeave: this.contract
      },
      renderActions(this.props, this.state)
    );
  },
  expand(event) {
    this.setState({ expanded: true });
  },
  contract(event) {
    this.setState({ expanded: false });
  }
});
